var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFXtz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "121px",
    viewBox: "0 0 105 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uA730XTZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "40.2650239 0 80.5301187 23.2469773 80.5301187 69.7408966 40.2650239 92.9877322 0 69.7408966 0 23.2469773"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uA730Tokens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uA730XTZ",
    transform: "translate(0.797678, 0.163865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.347232,31.4871635 L51.9614278,2.97433393 L2.57584899,31.487167 L2.57584899,88.5129442 L51.9614278,117.025669 L101.347232,88.5129476 L101.347232,31.4871635 Z M51.9598795,8.92022235 L96.193186,34.4600072 L96.193186,85.5360352 L51.9598795,111.07582 L7.72657297,85.5360352 L7.72657297,34.4600072 L51.9598795,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.923081,30 L51.9614247,0 L0,30 L0,90.0001126 L51.9614247,120 L103.923081,90.0001196 L103.923081,30 Z M51.9614308,5.94866785 L98.7713832,32.9743327 L98.7713832,87.0257757 L51.9614308,114.051338 L5.15169797,87.0257757 L5.15169797,32.9743327 L51.9614308,5.94866785 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(11.697080, 13.507835)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.675983, -2.447105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9410422,97.8819427 C75.9705003,97.8819427 97.8820844,75.9703586 97.8820844,48.9409005 C97.8820844,21.9116195 75.9705003,0 48.9410422,0 C21.9116195,0 0,21.9116195 0,48.9409005 C0,75.9703586 21.9116195,97.8819427 48.9410422,97.8819427 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2115601,62.4137395 C68.6234492,52.0067325 55.5315877,47.2762747 54.2786557,46.7904439 C54.2275156,46.7648739 54.2275156,46.7137338 54.2530856,46.6625937 L67.7540677,33.1104715 L67.7540677,31.6529791 C67.7463967,31.4151778 67.5571784,31.2259594 67.319377,31.2182884 L42.4397263,31.2182884 L42.4397263,23.0614451 L42.4397263,23.0614451 L42.4397263,20.6067211 L33.2600812,22.5244742 L33.2600812,23.9052565 L33.7714821,23.9052565 C33.7714821,23.9052565 36.0216458,23.9052565 36.0216458,26.1554201 L36.0216458,31.1927184 L28.9131741,31.1927184 C28.7750959,31.2029464 28.6677017,31.3103406 28.6574737,31.4484188 L28.6574737,34.644674 L36.0472158,34.644674 L36.0472158,52.0067325 C36.0472158,57.4531514 39.5503115,61.2375176 45.6871216,60.7261168 C46.9502817,60.6008236 48.1648587,60.1610188 49.2157874,59.4476147 C49.6786051,59.1510022 49.9573186,58.6421583 49.9573186,58.0924024 L49.9573186,56.3792096 C47.9628553,57.7088518 46.2752326,57.6321417 46.2752326,57.6321417 C42.3885862,57.6321417 42.4652963,52.6971236 42.4652963,52.6971236 L42.4652963,34.644674 L60.3643256,34.644674 L47.4770245,47.6342553 C47.4514545,49.3474481 47.4258844,50.6770903 47.4258844,50.7026603 C47.4207704,50.7410154 47.4488975,50.7742565 47.4872525,50.7793705 C47.4923666,50.7793705 47.4974806,50.7793705 47.5025946,50.7793705 C59.3159539,52.7738337 62.5122092,60.4192763 62.5122092,62.6438699 C62.5122092,62.6438699 63.7907112,73.4599976 52.9745835,74.2015288 C52.9745835,74.2015288 45.8916819,74.5083693 44.6387499,71.6700947 C44.5927238,71.5780425 44.6336359,71.4655344 44.725688,71.4220653 C44.730802,71.4195083 44.735916,71.4169513 44.74103,71.4143943 C45.945379,70.9106644 46.7252653,69.7293285 46.7099233,68.4226994 C46.7099233,66.3259559 45.4314212,64.6127631 42.7465668,64.6127631 C40.5731132,64.6127631 38.7832103,66.3259559 38.7832103,68.4226994 C38.7832103,68.4226994 37.7604086,77.5256343 52.9490135,77.2699339 C70.2855019,76.9630934 69.2115601,62.4137395 69.2115601,62.4137395 Z",
    id: "s",
    fill: "#505050"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFXtz);
export default __webpack_public_path__ + "static/media/fXTZ.c94d74d6dce01d2da3cd39fbfecaa9d9.svg";
export { ForwardRef as ReactComponent };